module.exports = __webpack_public_path__ + "static/img/bg-id.b0a6ddb3.png";